import { Icon, IconProps } from "@chakra-ui/react";
import { SVGProps } from "react";

export function BankIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M24.0555 9.2963L12.6481 1L1.24072 9.2963H24.0555Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3889 10.7778H16.6481"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3889 20.8518H16.6481"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8334 10.7778V20.8519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2037 10.7778V20.8519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8704 10.7778H10.1296"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8704 20.8518H10.1296"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3148 10.7778V20.8519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6852 10.7778V20.8519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35182 10.7778H3.61108"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35182 20.8518H3.61108"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.79626 10.7778V20.8519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16663 10.7778V20.8519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6859 8.25924C12.6035 8.25924 12.5361 8.2312 12.4837 8.17511C12.4313 8.12277 12.4051 8.05734 12.4051 7.97883V7.47971L12.5343 7.60309C12.2758 7.59561 12.0455 7.56196 11.8433 7.50214C11.6448 7.44232 11.4763 7.37315 11.3377 7.29464C11.2703 7.25351 11.2235 7.20304 11.1973 7.14322C11.1711 7.07966 11.1617 7.0161 11.1692 6.95254C11.1767 6.88898 11.1991 6.83477 11.2366 6.78991C11.2778 6.7413 11.3283 6.71139 11.3883 6.70018C11.4482 6.68522 11.5175 6.70018 11.5961 6.74504C11.701 6.80486 11.8377 6.86281 12.0062 6.91889C12.1785 6.97124 12.3845 6.99741 12.6241 6.99741C12.8114 6.99741 12.9631 6.97497 13.0792 6.93011C13.1953 6.88524 13.2795 6.82356 13.332 6.74504C13.3881 6.66653 13.4162 6.5768 13.4162 6.47585C13.4162 6.3936 13.3975 6.32256 13.36 6.26274C13.3226 6.19918 13.2608 6.14497 13.1747 6.10011C13.0885 6.0515 12.9724 6.01225 12.8264 5.98234L12.2309 5.85335C11.8901 5.77857 11.6354 5.65333 11.4669 5.4776C11.2984 5.30188 11.2141 5.07195 11.2141 4.7878C11.2141 4.56722 11.2684 4.37093 11.377 4.19895C11.4856 4.02323 11.6373 3.88302 11.8321 3.77834C12.0268 3.67365 12.2552 3.61196 12.5174 3.59327L12.4051 3.67739V3.20631C12.4051 3.1278 12.4313 3.06237 12.4837 3.01003C12.5361 2.95394 12.6035 2.9259 12.6859 2.9259C12.7646 2.9259 12.8301 2.95394 12.8825 3.01003C12.9387 3.06237 12.9668 3.1278 12.9668 3.20631V3.67739L12.8488 3.58766C13.0099 3.5914 13.1859 3.62318 13.3769 3.683C13.5716 3.74282 13.7383 3.82694 13.8769 3.93537C13.933 3.98023 13.9705 4.03257 13.9892 4.0924C14.0079 4.14848 14.0098 4.20456 13.9948 4.26064C13.9798 4.31298 13.9518 4.35785 13.9106 4.39523C13.8694 4.43262 13.8169 4.45505 13.7533 4.46253C13.6934 4.46627 13.6241 4.44571 13.5454 4.40084C13.4368 4.33728 13.3151 4.28681 13.1803 4.24942C13.0455 4.2083 12.8844 4.18773 12.6972 4.18773C12.4575 4.18773 12.2684 4.24195 12.1298 4.35037C11.995 4.45505 11.9276 4.59339 11.9276 4.76537C11.9276 4.89249 11.9688 4.9953 12.0511 5.07382C12.1335 5.14859 12.274 5.20841 12.4725 5.25328L13.0848 5.38787C13.4443 5.46639 13.7083 5.59164 13.8769 5.76362C14.0454 5.93186 14.1296 6.15432 14.1296 6.43099C14.1296 6.64783 14.0753 6.84038 13.9667 7.00862C13.8581 7.17313 13.7083 7.30585 13.5173 7.4068C13.3301 7.50401 13.111 7.5657 12.8601 7.59187L12.9668 7.4741V7.97883C12.9668 8.05734 12.9406 8.12277 12.8882 8.17511C12.8357 8.2312 12.7683 8.25924 12.6859 8.25924Z"
        fill="currentColor"
      />
      <path
        d="M23.1666 22.3334H1.83331"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 23.963H0.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function BankIcon2({ ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1238_73)">
        <path
          d="M13.5898 5.19529C13.8164 5.19529 14 5.01165 14 4.78514V3.14451C14 2.97873 13.9002 2.82921 13.747 2.76569L7.1572 0.0313154C7.05655 -0.0104385 6.94345 -0.0104385 6.8428 0.0313154L0.252957 2.76569C0.0998047 2.82921 0 2.97873 0 3.14451V4.78514C0 5.01165 0.183641 5.19529 0.410156 5.19529H1.12109V9.84373H0.984375C0.757859 9.84373 0.574219 10.0274 0.574219 10.2539V11.4844H0.410156C0.183641 11.4844 0 11.668 0 11.8945V13.5898C0 13.8163 0.183641 14 0.410156 14H13.5898C13.8164 14 14 13.8163 14 13.5898V11.8945C14 11.668 13.8164 11.4844 13.5898 11.4844H13.4258V10.2539C13.4258 10.0274 13.2421 9.84373 13.0156 9.84373H12.8789V5.19529H13.5898ZM13.1797 12.3047V13.1797H0.820312V12.3047H13.1797ZM3.30859 10.664V11.4844H1.39453V10.664H3.30859ZM1.94141 9.84373V5.19529H2.76172V9.84373H1.94141ZM3.71875 9.84373H3.58203V5.19529H10.418V9.84373H10.2812C10.0547 9.84373 9.87109 10.0274 9.87109 10.2539V11.4844H4.12891V10.2539C4.12891 10.0274 3.94527 9.84373 3.71875 9.84373ZM12.6055 10.664V11.4844H10.6914V10.664H12.6055ZM11.2383 9.84373V5.19529H12.0586V9.84373H11.2383ZM0.820312 4.37498V3.41839L7 0.854198L13.1797 3.41836V4.37498H0.820312Z"
          fill="#4E5762"
        />
        <path
          d="M9.46094 2.73438H4.53906C4.31255 2.73438 4.12891 2.91802 4.12891 3.14453C4.12891 3.37105 4.31255 3.55469 4.53906 3.55469H9.46094C9.68745 3.55469 9.87109 3.37105 9.87109 3.14453C9.87109 2.91802 9.68745 2.73438 9.46094 2.73438Z"
          fill="#4E5762"
        />
        <path
          d="M7 9.57031C6.77384 9.57031 6.58984 9.38632 6.58984 9.16016C6.58984 8.93364 6.4062 8.75 6.17969 8.75C5.95317 8.75 5.76953 8.93364 5.76953 9.16016C5.76953 9.69486 6.11245 10.1508 6.58984 10.3201V10.5273C6.58984 10.7539 6.77348 10.9375 7 10.9375C7.22652 10.9375 7.41016 10.7539 7.41016 10.5273V10.3201C7.88755 10.1508 8.23047 9.69486 8.23047 9.16016C8.23047 8.48168 7.67848 7.92969 7 7.92969C6.77384 7.92969 6.58984 7.74569 6.58984 7.51953C6.58984 7.29337 6.77384 7.10938 7 7.10938C7.22616 7.10938 7.41016 7.29337 7.41016 7.51953C7.41016 7.74605 7.5938 7.92969 7.82031 7.92969C8.04683 7.92969 8.23047 7.74605 8.23047 7.51953C8.23047 6.98482 7.88755 6.52892 7.41016 6.35961V6.15234C7.41016 5.92583 7.22652 5.74219 7 5.74219C6.77348 5.74219 6.58984 5.92583 6.58984 6.15234V6.35961C6.11245 6.52892 5.76953 6.98482 5.76953 7.51953C5.76953 8.19801 6.32152 8.75 7 8.75C7.22616 8.75 7.41016 8.934 7.41016 9.16016C7.41016 9.38632 7.22616 9.57031 7 9.57031Z"
          fill="#4E5762"
        />
      </g>
      <defs>
        <clipPath id="clip0_1238_73">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
